import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const mapV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Map element to v2 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'map'>): void => {
    const mapProps = props;

    if (mapProps?.style?.map?.title && !mapProps?.content?.title?.iconColor) {
      const currentColor = mapProps.style.map.title.color1;
      mapProps.content = {
        ...mapProps.content,
        title: {
          ...mapProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
